module.exports = __webpack_public_path__ + "img/doctor-lite.333484cf.png";